import { render, staticRenderFns } from "./SettingsModules.vue?vue&type=template&id=778d47ea&scoped=true"
import script from "./SettingsModules.vue?vue&type=script&lang=js"
export * from "./SettingsModules.vue?vue&type=script&lang=js"
import style0 from "./SettingsModules.vue?vue&type=style&index=0&id=778d47ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778d47ea",
  null
  
)

export default component.exports